// extracted by mini-css-extract-plugin
export var content = "QuoteAndText-module--content--2yRGi";
export var image = "QuoteAndText-module--image--0+Aia";
export var imageWrapper = "QuoteAndText-module--imageWrapper--psDmh";
export var label = "QuoteAndText-module--label--V5HYg";
export var labelPrint = "QuoteAndText-module--labelPrint--jak3K";
export var link = "QuoteAndText-module--link--6e5dG";
export var quote = "QuoteAndText-module--quote--DdFIJ";
export var wrapper = "QuoteAndText-module--wrapper--57P8f";